import PropTypes from 'prop-types';
import React from 'react';
import {styled} from '@mui/material/styles';

const Wrapper = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  maxWidth: theme.spacing(5), // width of a single button
  '&:not(:last-of-type)': {
    marginBottom: theme.spacing(2),
  },
  '& > div, & > button': {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(0.5),
    },
  },
}));

const MapToolsGroup = props => {
  return <Wrapper>{props.children}</Wrapper>;
};

MapToolsGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MapToolsGroup;
